module.exports = __webpack_public_path__ + "0b4f910e6ec634a4ded6b0f80105165e.svg";